import React from "react"
import Cross from "assets/svgs/Cross"
import ButtonGroup from "core/components/v2/ButtonGroup"
import { STR_CLASSES, STR_EXAMS, STR_MENTORSHIP } from "core/constants/strings"
import ProgressMeetViewModel from "../ProgressMeetViewModel"
import DonutChart2 from "./DonutChart2"
import ExamsBarChart from "./ExamsBarGraph"
import MentorshipBarChart from "./MentorshipBarGraph"
import SummaryModalButtons from "./SummaryModalButtons"
import Loader from "core/components/Loader"
interface SummaryFeedbackModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  batches: string[]
  meetingDate: number
}
export default function SummaryModal({ isOpen, setIsOpen, batches, meetingDate }: SummaryFeedbackModalProps) {
  const {
    changeActiveButtonType,
    activeButtonType,
    highlyActiveStudent,
    inActiveStudent,
    passiveActiveStudent,
    activeStudent,
    toppedStudent,
    passedStudent,
    failedStudent,
    bookedStudent,
    attendedStudent,
    examTitle,
    mentorshipTitle,
    getClassAttendanceStats,
    getExamStats,
    getMentorshipStats,
    setHighlyActiveStudent,
    setActiveStudent,
    setPassiveActiveStudent,
    setInActiveStudent,
    setBookedStudent,
    setAttendedStudent,
    setToppedStudent,
    setPassedStudent,
    setFailedStudent,
    setActiveButtonType,
    mentorshipLoading,
    classLoading,
    examLoading,
  } = ProgressMeetViewModel()
  React.useEffect(() => {
    if (isOpen) {
      getMentorshipStats(batches, meetingDate)
      getClassAttendanceStats(batches, meetingDate)
      getExamStats(batches, meetingDate)
    }
  }, [isOpen])
  if (!isOpen) return null
  const handleCloseClick = () => {
    setIsOpen(false)
    setHighlyActiveStudent(0)
    setActiveStudent(0)
    setPassiveActiveStudent(0)
    setInActiveStudent(0)
    setToppedStudent(0)
    setPassedStudent(0)
    setFailedStudent(0)
    setBookedStudent(0)
    setAttendedStudent(0)
    setActiveButtonType(0)
  }
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0  bg-[rgba(12,12,12,0.9)] z-0"></div>
      <div className="relative bg-white w-[564px] h-[578px] p-6 rounded-lg shadow-lg z-10 ">
        <div className="flex justify-between">
          <div>
            <h4 className="text-black text-lg font-semibold text-left">Meeting Summary </h4>
            <p className="text-gray-700 ">Gist of your current meeting </p>
          </div>

          <button className="hover:bg-[#D3D3D3] duration-500 rounded-sm h-[24px]" onClick={handleCloseClick}>
            <Cross />
          </button>
        </div>
        {!examLoading && !classLoading && !mentorshipLoading ? (
          <>
            <div className="w-fit mt-4 ">
              <SummaryModalButtons
                className=" w-[85px] h-[35px] rounded-[4px] p-[9px_16px] min-w-auto"
                buttons={[STR_CLASSES, STR_EXAMS, STR_MENTORSHIP]}
                active={activeButtonType}
                onChange={changeActiveButtonType}
              />
            </div>
            {activeButtonType === 0 && (
              <div className="flex w-[526px] h-[57px] mt-3 p-[12px_16px] flex-col items-start gap-[10px] rounded-[8px] "></div>
            )}
            {activeButtonType === 1 && (
              <div className="flex w-[526px] h-[57px] mt-3 p-[12px_16px] flex items-start justify-between rounded-[8px] bg-[#F9F9F9]">
                <div className="text-[#333] font-inter text-[14px] font-semibold leading-normal mt-[4px]">
                  Exam Title
                </div>

                <div className="rounded-[4px] border-[1px] border-[#D3D3D3] bg-white flex w-[300px] h-[33px] py-[8px] px-[16px] items-center overflow-hidden">
                  <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal truncate">
                    {examTitle}
                  </p>
                </div>
              </div>
            )}
            {activeButtonType === 2 && (
              <div className="flex w-[526px] h-[57px] mt-3 p-[12px_16px] flex items-start justify-between rounded-[8px] bg-[#F9F9F9]">
                <div className="text-[#333] font-inter text-[14px] font-semibold leading-normal mt-[4px]">
                  Mentor Session title{" "}
                </div>
                <div className="rounded-[4px] border-[1px] border-[#D3D3D3] bg-white flex w-[300px] h-[33px] py-[8px] px-[16px] items-center overflow-hidden">
                  <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal truncate">
                    {mentorshipTitle}
                  </p>
                </div>
              </div>
            )}
            <div className=" mt-3 flex justify-between items-center">
              {activeButtonType === 0 && (
                <DonutChart2
                  highlyActiveStudent={highlyActiveStudent}
                  inActiveStudent={inActiveStudent}
                  passiveActiveStudent={passiveActiveStudent}
                  activeStudent={activeStudent}
                />
              )}
              {activeButtonType === 1 && (
                <ExamsBarChart
                  toppedStudent={toppedStudent}
                  passedStudent={passedStudent}
                  failedStudent={failedStudent}
                />
              )}
              {activeButtonType === 2 && (
                <MentorshipBarChart bookedStudent={bookedStudent} attendedStudent={attendedStudent} />
              )}
            </div>
          </>
        ) : (
          <div className="flex justify-center items-center h-full">
            <Loader />
          </div>
        )}
      </div>
    </div>
  )
}
